export const TICK_RATE = 20;
export const TICK_INTERVAL_MS = 1000 / TICK_RATE;
export const SNAPSHOT_BUFFER_MS = 100;

export const PLAYER_SPEED = 7;
export const PLAYER_SPRINT_MULTIPLIER = 1.5;
export const JUMP_VELOCITY = 8;
export const GRAVITY = 25;

export const GROUND_ACCEL = 12;
export const GROUND_FRICTION = 7;
export const STOP_SPEED = 1.5;
export const AIR_ACCEL = 7;
export const AIR_WISH_SPEED = 3;
export const COYOTE_TIME = 0.1;
export const JUMP_BUFFER_TIME = 0.15;

// Dodge / dive
export const DODGE_SPEED = 14;
export const DODGE_DURATION_S = 0.25;
export const DODGE_COOLDOWN_S = 1.5;
export const DODGE_UPWARD_BOOST = 2.0;
export const PLAYER_HEIGHT = 1.8;
export const PLAYER_RADIUS = 0.4;
export const PLAYER_EYE_HEIGHT = 1.6;

// All spawns are checked against MAP_BOXES — keep clear of any obstacle's
// AABB (player radius 0.4).
export const SPAWN_POSITIONS = [
  { x:  4, y: 0.5, z:  8 },
  { x: -4, y: 0.5, z:  8 },
  { x:  4, y: 0.5, z: -6 },
  { x: -4, y: 0.5, z: -4 },
  { x: 14, y: 0.5, z:  2 },
  { x:-14, y: 0.5, z:  0 },
  { x:  0, y: 0.5, z: 14 },
  { x:  6, y: 0.5, z: -22 },
];

export const MAX_PLAYERS = 16;

// Weapon-specific constants now live in classes.ts (per-class WeaponDef).
export const PLAYER_MAX_HP = 100;
export const LAG_COMPENSATION_MS = SNAPSHOT_BUFFER_MS;
export const HISTORY_SAMPLES = 16;
